// Module
var code = "<div>\n    <inv-select name=\"behaviour\" ng-model=\"row.entity.Behaviour\">\n        <inv-option ng-repeat=\"option in grid.appScope.NBAWidget.behaviourOptions\" value=\"option\"><span ng-bind=\"option\"></span></inv-option>\n    </inv-select>\n</div>";
// Exports
module.exports = code;